// GENERATED FILE - DO NOT MODIFY
export enum InspectionContext {
    Equipment = 0,
    Project = 1,
    ServiceCall = 2,
}

export let nameof = "InspectionContext";
